export const INELIGIBLE_CONTRACT_ERROR_MESSAGE =
  'Contrato selecionado está indisponível para solicitação de reparos.'
